// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"c252da9d","787":"40b5365c","827":"68749850"}[chunkId] + ".chunk.js";
};